import { FixedSizeList as List } from "react-window";
import { Box, TextField, MenuItem, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export const Dropdown = ({
  handleChange,
  value,
  data,
  isOpen,
  setIsOpen,
  medicine_value,
  is_formula_drop,
  addNewMed,
  product_name,
  stickyFooter,
}: any) => {
  const listRef = useRef<any>(null); // Updated to store list ref
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const handleTextFieldFocus = () => {
    setIsOpen(true);
  };
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        event.target instanceof HTMLElement &&
        !event.target.closest(".dropdown-container")
      ) {
        setIsOpen(false);

        // 💡 Check if input is cleared and call medicine_value(null)
        if (value === "") {
          medicine_value(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, value]);

  const handleItemClick = (item: any) => {
    const formattedValue = is_formula_drop
      ? item.name
      : `${item.name} (${item.dose})`;
    handleChange({ target: { value: formattedValue } });
    medicine_value(item);
    setIsOpen(false); // Optionally close dropdown after selection
  };
  const scrollIntoView = (index: number) => {
    if (listRef.current) {
      listRef.current.scrollToItem(index); // Scroll to the item in the virtualized list
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setHighlightedIndex((prevIndex) => {
        const newIndex = Math.min(prevIndex + 1, data.length - 1);
        scrollIntoView(newIndex);
        return newIndex;
      });
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setHighlightedIndex((prevIndex) => {
        const newIndex = Math.max(prevIndex - 1, 0);
        scrollIntoView(newIndex);
        return newIndex;
      });
    } else if (event.key === "Enter") {
      event.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < data.length) {
        handleItemClick(data[highlightedIndex]);
      }
    }
  };

  // Render a single row in the virtualized list
  const Row = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => (
    <MenuItem
      key={data[index].id}
      onClick={() => handleItemClick(data[index])}
      selected={highlightedIndex === index}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        backgroundColor: highlightedIndex === index ? "lightgray" : "white",
      }}
      data-index={index} // Add data-index attribute to the menu item
    >
      <Box>{data[index]?.name}</Box>
      {!is_formula_drop && (
        <Box sx={{ ml: "2px", fontSize: "12px" }}>({data[index]?.dose})</Box>
      )}
    </MenuItem>
  );
  const handleChangeWrapper = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    handleChange(event); // Call the original handleChange function
    if (newValue === "") {
      setHighlightedIndex(-1); // Reset highlightedIndex when the field is cleared
      medicine_value(null); // <- Trigger clearing logic in parent
    }
  };
  return (
    <div
      className="dropdown-container"
      style={{ position: "relative", zIndex: 10 }}
    >
      <TextField
        fullWidth
        value={value}
        onChange={handleChangeWrapper}
        variant="outlined"
        placeholder={
          is_formula_drop
            ? "Select Medicine Formula"
            : product_name
              ? "Name"
              : " Name"
        }
        onFocus={handleTextFieldFocus}
        onKeyDown={handleKeyDown}
        sx={{ backgroundColor: "white" }}
        inputProps={{
          style: {
            padding: "10px 12px",
          },
        }}
      />
      {/* {!is_formula_drop ? ( */}
        <button
          style={{
            position: "absolute",
            top: 6,
            right: 16,
            height: "75%",
            borderRadius: 0,
            background: "white",
            color: "#0A8DD0",
            border: "none",
            padding: 0,
            cursor: "pointer",
            outline: "inherit",
            fontSize: "14px",
            fontWeight: 400,
          }}
          type="button"
          onClick={addNewMed}
        >
          + Add as New
        </button>
      {/* ) : null} */}

      {isOpen && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height:
              data.length === 0
                ? (stickyFooter ? '70px' : 'auto')
                : data.length < 5
                  ? `${data.length * 50 + (stickyFooter ? 60 : 0)}px`
                  : `${250 + (stickyFooter ? 60 : 0)}px`,
            width: is_formula_drop
              ? {
                xs: '335px',
                sm: '215px',
                lg: '375px',
              }
              : {
                xs: '335px',
                sm: '213px',
                lg: '315px',
              },
            '@media (min-width: 300px) and (max-width: 360px)': {
              width: '265px',
            },
            '@media (min-width: 361px) and (max-width: 375px)': {
              width: '280px',
            },
            '@media (min-width: 377px) and (max-width: 390px)': {
              width: '294px',
            },
            '@media (min-width: 391px) and (max-width: 414px)': {
              width: '317px',
            },
            '@media (min-width: 820px) and (max-width: 911px)': {
              width: '230px',
            },
            '@media (min-width: 912px) and (max-width: 1023px)': {
              width: '264px',
            },
            '@media (min-width: 1024px) and (max-width: 1279px)': {
              width: '300px',
            },
            zIndex: 5,
            position: 'absolute',
            top: '100%',
            bgcolor: 'white',
            borderRadius: '5px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
            p: 0,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ flex: '1 1 auto', overflowY: 'auto', minHeight: 0 }}>
            {data.length === 0 ? (
              <Typography
                sx={{
                  padding: '10px',
                  color: 'gray',
                  fontSize: '16px',
                }}
              >
                No options
              </Typography>
            ) : (
              <List
                ref={listRef}
                height={250}
                itemCount={data.length}
                itemSize={50}
                width="100%"
              >
                {Row}
              </List>
            )}
          </Box>
          {stickyFooter && (
            <Box
              sx={{
                flex: '0 0 auto',
                position: 'sticky',
                bottom: 0,
                bgcolor: 'white',
                borderTop: '1px solid #eee',
                p: 1,
                textAlign: 'center',
                zIndex: 2,
              }}
            >
              {stickyFooter}
            </Box>
          )}
        </Box>
      )}
    </div>
  );
};
